import {ErrorResponse, isErrorResponse} from "./types/response/ErrorResponse";
import {Promise} from "@securionpay-internal/commons-js";
import Tracker from "../Tracker";

export class ServerResultHandler {

    private readonly tracker: Tracker

    constructor(tracker: Tracker) {
        this.tracker = tracker;
    }

    handleCallback<R>(
        prefix: string,
        payload: (result: R) => any,
        errorPayload: (result: ErrorResponse) => any = res => ({error: res.error})
    ): (r:R | ErrorResponse) => Promise<R> {
        return result => this.handle(prefix, result, payload, errorPayload)
    }

    handle<R>(
        prefix: string,
        result: ErrorResponse | R,
        payload: (result: R) => any,
        errorPayload: (result: ErrorResponse) => any = res => ({error: res.error})
    ): Promise<R> {
        if (isErrorResponse(result)) {
            return this.tracker.track(prefix + ".server_error", errorPayload(result))
                .then(() => Promise.reject(result.error))
        }
        return this.tracker.track(prefix + ".success", payload(result))
            .then(() => Promise.resolve(result))
    }

    handleNoTrack<R>(
        result: ErrorResponse | R,
    ): Promise<R> {
        if (isErrorResponse(result)) {
            return Promise.reject(result.error)
        }
        return Promise.resolve(result)
    }

    handleNoTrackCallback<R>(): (r:R | ErrorResponse) => Promise<R> {
        return result => this.handleNoTrack(result)
    }
}
